import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { circolariRappresentanteApi } from '../../services/circolariRappresentanteService';
import DettaglioCircolare from '../../components/circolari/DettaglioCircolare';
import {
  AccessoCircolari,
  AvvisoAccessoCircolari,
  ShellCircolari,
  gestoreAccessoCircolari,
  useProfiloRappresentante,
} from './AssociativeCircolari';

const ELENCO = '/area-associativa/circolari';

/** Dettaglio di una circolare nell'area associativa (rappresentanti). */
const AssociativeCircolareDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const profile = useProfiloRappresentante();
  const [accesso, setAccesso] = useState<AccessoCircolari>('ok');
  const onErroreAccesso = gestoreAccessoCircolari(setAccesso);

  return (
    <ShellCircolari profile={profile}>
      <div className="page fade-in">
        {accesso !== 'ok' ? (
          <AvvisoAccessoCircolari accesso={accesso} />
        ) : (
          <div className="max-w-3xl">
            <button
              type="button"
              onClick={() => navigate(ELENCO)}
              className="inline-flex items-center gap-1.5 text-xs text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 mb-4 transition-colors"
            >
              <ArrowLeft className="w-3.5 h-3.5" />
              Torna alle circolari
            </button>
            <DettaglioCircolare
              api={circolariRappresentanteApi}
              id={id}
              linkElenco={ELENCO}
              etichettaRitorno="Torna alle circolari"
              testoNonTrovata="La circolare non esiste più oppure non è più pubblicata."
              onErroreAccesso={onErroreAccesso}
            />
          </div>
        )}
      </div>
    </ShellCircolari>
  );
};

export default AssociativeCircolareDetail;
